import { render } from "./ServiceDescription.vue?vue&type=template&id=43ae5457"
const script = {}

import exportComponent from "/home/afreet/public_html/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__